import { gql } from '@apollo/client';
import { PATIENT_PROGRESS } from '../../types';

export interface CreatePatientInput {
  signupCode: string;
  clinicId?: string;
  clinicianId?: string;
  email?: string;
  nameFirst: string;
  nameLast: string;
  dob?: string;
  phone?: string;
  allowSms?: string;
  allowEmail?: string;
  riskLevel?: string;
  progress?: string;
  sessionDate?: string;
  tz?: string;
}

export interface UpdatePatientInfoInput {
  signupCode: string;
  nameFirst?: string;
  nameLast?: string;
  dob?: string;
  phoneMobile?: string;
  email?: string;
  progress?: PATIENT_PROGRESS;
}

export const PATIENT_CREATE = gql`
  mutation createPatient($input: CreatePatientInput!) {
    createPatient(input: $input) {
      id
      signupCode
    }
  }
`;

export const DISCHARGE_PATIENT = gql`
  mutation dischargePatient($signupCode: String!) {
    dischargePatient(signupCode: $signupCode) {
      id
      signupCode
      nameFirst
      nameLast
      email
      progress
    }
  }
`;

export const UPDATE_PATIENT_INFO = gql`
  mutation updatePatientInfo($input: UpdatePatientInfoInput!) {
    updatePatientInfo(input: $input) {
      id
      signupCode
      nameFirst
      nameLast
      dob
      email
      phoneMobile
      progress
    }
  }
`;

export interface IInvitePatientArgs {
  signupCode: string;
  overrideResend?: boolean;
}

export const PATIENT_INVITE = gql`
  mutation invitePatientViaDynamicLink($signupCode: String!, $overrideResend: Boolean) {
    invitePatientViaDynamicLink(
      input: { signupCode: $signupCode, overrideResend: $overrideResend }
    ) {
      notification {
        via
        userId
        signupCode
        createdAt
      }
      dynamicLink
    }
  }
`;

export interface CourseEnrollmentInput {
  courseId: string;
  startDate: string;
}

export interface ProtocolEnrollmentInput {
  protocolId: string;
  startDate: string;
}

export enum TherapyType {
  groupTherapy = 'group_therapy',
  oneToOneTherapy = 'one_to_one_therapy',
  preparationForTherapy = 'preparation_for_therapy',
}

export interface AddPatientTherapyInput {
  type: TherapyType;
  signupCode: string;
  courseEnrollments: CourseEnrollmentInput[];
  protocolEnrollments: ProtocolEnrollmentInput[];
  clinicianId?: string;
  allowFirstInteractionInThePast: boolean;
}

export const ADD_PATIENT_THERAPY = gql`
  mutation addPatientTherapy($input: AddPatientTherapyInput!) {
    addPatientTherapy(input: $input) {
      id
      signupCode
      nameFirst
      nameLast
      email
      progress
    }
  }
`;
